import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import s from './styles.module.scss'

import { useDateFormatter } from '../../../../lib/hooks'
import { vatStatusToLabel } from '../../../../utils'
import { decimalPrice } from '../../../../utils/currencyFormatter'
import { useCurrencyAreaContext, VAT_STATUS } from '../../../contexts'

interface IBookingInfoPaymentProps {
  showTitle?: boolean
  paymentDate?: string
  priceWithoutVat?: number
  priceWithVat?: number
  clientRequestNumber?: string
}
const BookingInfoPayment = ({
  showTitle = true,
  paymentDate,
  priceWithoutVat,
  priceWithVat,
  clientRequestNumber,
}: IBookingInfoPaymentProps) => {
  const intl = useIntl()
  const { currency } = useCurrencyAreaContext()
  const dateFormatter = useDateFormatter()

  return (
    <div className={s.payment}>
      {showTitle && (
        <div className={s.title}>
          <FormattedMessage
            id='ui.BookingInfoPayment.paymentInformations'
            defaultMessage='Informations de paiements'
          />
        </div>
      )}

      <div className={s.row}>
        <FormattedMessage
          id='ui.BookingInfoPayment.bookingNumber'
          defaultMessage='Réservation n°'
        />
        {clientRequestNumber}
      </div>

      <div className={s.row}>
        <FormattedMessage
          id='ui.BookingInfoPayment.paidAt'
          defaultMessage='Payée le'
        />
        &nbsp;
        {paymentDate
          ? dateFormatter.format({
              date: paymentDate,
              formatString: 'dayMonthYear',
            })
          : 'XX/XX/XXXX'}
      </div>
      <div className={s.row}>
        <FormattedMessage
          id='ui.BookingInfoPayment.totalCost'
          defaultMessage='Coût total :'
        />
        &nbsp;
        {decimalPrice(priceWithoutVat, { currency })}
        {vatStatusToLabel({ vatStatus: VAT_STATUS.HT, intl })}
        &nbsp;/&nbsp;
        {decimalPrice(priceWithVat, { currency })}
        {vatStatusToLabel({ vatStatus: VAT_STATUS.TTC, intl })}
      </div>
    </div>
  )
}

export default BookingInfoPayment
